<template>
    <div class="order-container new-cell-group">
        <template v-if="!isInitialized">
            <div class="card-container">
                <div class="card-option">
                    <van-empty description="正在读取中..."/>
                </div>
            </div>
        </template>
        <template v-if="isInitialized">
            <van-cell-group class="detail-container" title="订单信息">
                <van-cell title="油品：">
                    <div>
                        <van-tag round :color="orderInfo.detail.oilModel | oilModelFormat" size="large">{{orderInfo.detail.oilModel}}</van-tag>
                        <van-tag round :color="orderInfo.detail.oilName | oilNameFormat" size="large">{{orderInfo.detail.oilName}}</van-tag>
                    </div>
                </van-cell>
                <van-cell title="交易时间：" :value="orderInfo.detail.created_at"/>
                <van-cell title="油量：" :value="orderInfo.detail.oil_liter + 'L'"></van-cell>
                <van-cell title="单价：" :value="orderInfo.detail.oil_price + '元/L'"></van-cell>
                <van-cell value-class="money" title="应收总额：" :value="`￥${orderInfo.total_amount}`"/>
            </van-cell-group>

            <van-cell-group title="优惠">
                <van-cell
					v-for="(discountItem, index) in discountDetailList"
					:key="'discount' + index"
					value-class="money"
					:title="discountItem.name + '：'">
                    <van-tag class="order-item-tag" size="large">{{discountItem.value}}</van-tag>
                </van-cell>
				<van-coupon-cell :coupons="couponList" :chosen-coupon="selectCouponIndex" @click="showCoupon = true"/>
				<van-cell title="邀请人：" :value="inviterNickname" v-if="inviterNickname" />
            </van-cell-group>


            <van-radio-group v-model="payType"
                             checked-color="#07c160"
                             @change="getOrderCheckout"
                             :disabled="isLoading">
                <van-cell-group title="请选择您的支付方式"
                                class="payment-container">
                    <van-cell title="微信支付"
                              clickable
                              @click="isLoading ? false : payType = 'wechat_jsapi'">
                        <template #icon>
                            <van-radio name="wechat_jsapi"/>
                        </template>
                        <van-loading v-if="isLoading && payType === 'wechat_jsapi'" class="payment-loading" color="#1989fa"/>
                    </van-cell>
                    <van-cell v-if="!cardIsNull"
                              title="油卡支付"
                              clickable
                              class="payment-balance_is_insufficient"
                              @click="isLoading ? false : payType = 'card'">
                        <template #icon>
                            <van-radio name="card"/>
                        </template>
                        <van-loading v-if="isLoading && payType === 'card'" class="payment-loading" color="#1989fa"/>
                    </van-cell>
                    <van-cell v-if="showCardCell" icon="debit-pay"
                              :title="cardInfos[0] ? 'No.' + (cardInfos[0].card_no || '') + (cardInfos.length > 1 ? '等共' + cardInfos.length + '张卡' : '') : '未选择'"
                              is-link
                              value-class="payment-balance"
                              @click="showCardPop()">
                        <template #default>
                            <div>￥{{cardInfos.length ? cardBalance : ''}}</div>
                        </template>
                        <template #label>
                            <div>点击重新选择油卡</div>
                            <div class="payment-hint" v-if="cardDisabled">存在不可用卡片,请重新选择</div>
                        </template>
                    </van-cell>
                </van-cell-group>
                <van-cell-group v-if="cardIsNull" title="办理油卡">
                    <van-cell icon="debit-pay"
							title="开通油卡可享受优惠"
							arrow-direction="down"/>
					<van-cell
							title="一键办卡"
							is-link
							@click="toHandle"/>
					<van-cell
							title="绑定油卡"
							is-link
							@click="$router.push({name: 'Binding'})"/>
                </van-cell-group>
            </van-radio-group>
            <van-submit-bar label="实付："
                            :price="orderInfo.paid_amount*100 || 0"
                            text-align="left"
                            button-text="支付订单"
                            :loading="paying"
                            :disabled="payType === 'card' && cardDisabled"
                            @submit="submitClick"/>

            <van-popup v-model="showCard" position="bottom" round :close-on-click-overlay="false">
                <div class="popup_tit">
                    <span>选择油卡</span>
                    <van-button type="primary" size="small" @click="confirmSelectCard()">确 认</van-button>
					<van-button type="primary" size="small" @click="cancelSelectCard()" style="margin-right: 10px;">取 消</van-button>
                </div>
                <div class="card-list">
                    <card-design v-for="(item, index) in cardList"
                                 :key="'card' + index"
                                 :card-info="item"
                                 :class="[{'item-disable': item.disabled}, 'card-item', {'item-selected': cardIds.indexOf(item.id) !== -1} ]"
                                 @click.native="selectCard(item)">
                        <div class="item-disable-shade" v-if="item.disabled">
                            <div class="message">
                                <van-icon name="warning-o" color="#ffffff" size="20"/>
                                <span>{{item.disabled_info.result == 'INSUFFICIENT_BALANCE' ? '余额不足，点击' : item.disabled_info.msg}}</span>
                                <span @click="toRecharge(item.id)" style="text-decoration: underline;" v-if="item.disabled_info.result == 'INSUFFICIENT_BALANCE'">充值</span>
                            </div>
                        </div>
						<div class="item-active-shade">
							<div v-if="cardIds.length > 1">
								<div class="text"></div>
								<span>{{cardIds.indexOf(item.id)+ 1}} </span>
							</div>
                            <van-icon name="success" color="#ffffff" size="20" v-if="cardIds.length === 1"/>
                        </div>
                    </card-design>
                </div>
            </van-popup>

            <van-popup v-model="showCoupon" round position="bottom" style="height: 90%; padding-top: 4px; overflow: hidden;">
                <van-coupon-list :coupons="couponList" :chosen-coupon="selectCouponIndex" :disabled-coupons="disabledCouponList" @change="couponChange" :show-exchange-bar="false" />
            </van-popup>

            <van-popup v-model="showPaymentPassword" position="bottom" style="height: 90%;">
                <div style="font-size: 18px; text-align: center; padding: 30px 0 10px 0;">输入支付密码</div>
                <div style="text-align: center; color: #888888; padding: 10px;">请输入支付密码，用于验证支付</div>
                <van-password-input :value="paymentPassword" :focused="showPaymentPasswordKeyboard" @focus="showPaymentPasswordKeyboard = true" />
                <van-number-keyboard v-model="paymentPassword" :show="showPaymentPasswordKeyboard" :maxlength="6" />
            </van-popup>
        </template>
    </div>
</template>

<script>
    import wx from 'weixin-js-sdk'
    import api from '../../assets/js/api'
    import cardDesign from '../../components/beilin/CardDesign'
    import mixin from '../mixin'
    import common from "../../assets/js/common";
    var fromName = '';
    export default {
        name: 'Order',
        components: {cardDesign},
        mixins: [mixin],
        beforeRouteEnter(to, from, next) {
            fromName = from.name
            next();
        },
        data () {
            return {
                isLoading: false,
                showCard: false,
                showCoupon : false,
                showCardCell: false,
                showPaymentPassword : false,
                showPaymentPasswordKeyboard : true,
                paymentPassword : '',
                paying: false, // 正在支付
                gunNumId: null,
                payType: undefined,
                cardInfos: [],
                orderInfo: {
                    detail : {},
                },
                cardList: [],
                cardIsNull: false,    // 油卡是否为空
                selectCouponIndex : -2,
                userCoupon : [],
				cardInfosReport: [],
				isInitialized: false,
				inviterId: '',
				inviterNickname: ''
            }
        },
        created() {
			let inviterInfo = JSON.parse(localStorage.getItem('consumeInviterInfo'));
			if (inviterInfo && inviterInfo.id) {
				this.inviterId = inviterInfo.id;
			}
            if (!fromName) {
                fromName = `Card`
            }

        },
        computed: {
            couponList(){
                let list = this.userCoupon;
                let couponArr = [];
                for (let index in list){
                    let coupon = list[index];
                    if(!coupon['disabled']){
                        couponArr.push(common.convertCouponData(coupon));
                        if(coupon['is_select']){
                            this.selectCouponIndex = couponArr.length - 1;
                        }
                    }
                }
                return couponArr;
            },
            disabledCouponList(){
                let list = this.userCoupon;
                let couponArr = [];
                for (let index in list){
                    let coupon = list[index];
                    if(coupon['disabled']){
                        couponArr.push(common.convertCouponData(coupon));
                    }
                }
                return couponArr;
            },
			cardIds() {
				let ids = []
				for (const card of this.cardInfos) {
					ids.push(card.id)
				}
				return ids
			},
			cardDisabled() {
				for (const card of this.cardInfos) {
					if (card.disabled) {
						return true
					}
				}
				return false
			},
			isCardAllGift() {
				for (const card of this.cardInfos) {
					if (card.type !== 'GiftCard') {
						return false
					}
				}
				return true
			},
			cardBalance() {
				let balance = 0;
				for (const card of this.cardInfos) {
					if (card.balance) {
						balance = this.accAdd(balance, card.balance)
					}
				}
				return balance
			},
			discountDetailList() {
				if (this.orderInfo.discount_detail && this.orderInfo.discount_detail.length > 0) {
					return this.orderInfo.discount_detail
				} else {
					return []
				}
			}
        },
        watch : {
            selectCouponIndex(newValue, oldValue){
                this.getOrderCheckout();
            },
            paymentPassword(newValue, oldValue){
                if(newValue.length >= 6){
                    this.payment();
                }
            },
        },
        mounted () {
            this.orderInfo.detail.order_id = this.$route.query.orderId || ''
            this.gunNumId = this.$route.query.gunNumId || ''
            this.getOrderCheckout()
        },
        methods: {
			accAdd(arg1, arg2) {
				var r1, r2, m, c;
				try {
					r1 = arg1.toString().split(".")[1].length;
				}
				catch (e) {
					r1 = 0;
				}
				try {
					r2 = arg2.toString().split(".")[1].length;
				}
				catch (e) {
					r2 = 0;
				}
				c = Math.abs(r1 - r2);
				m = Math.pow(10, Math.max(r1, r2));
				if (c > 0) {
					var cm = Math.pow(10, c);
					if (r1 > r2) {
						arg1 = Number(arg1.toString().replace(".", ""));
						arg2 = Number(arg2.toString().replace(".", "")) * cm;
					} else {
						arg1 = Number(arg1.toString().replace(".", "")) * cm;
						arg2 = Number(arg2.toString().replace(".", ""));
					}
				} else {
					arg1 = Number(arg1.toString().replace(".", ""));
					arg2 = Number(arg2.toString().replace(".", ""));
				}
				return (arg1 + arg2) / m;
			},
            // 跳转至办卡页面
            toHandle () {
                this.$router.push({name: 'CardHandle'})
            },

            toRecharge (id) {
                this.$router.push({name: 'Recharge', query: {from: 'order', user_card_id: id}})
            },

            // 订单结算信息获取
            getOrderCheckout () {
                if (this.isLoading) return;
                this.isLoading = true
				let self = this;
                api.request('/order/checkout', {
                    site_oil_gun_id: this.gunNumId, // 油枪ID
                    order_id: this.orderInfo.detail.order_id, // 订单ID
                    payment_method: this.payType, // 支付方式
                    user_card_id: this.cardIds, // 卡片ID
					inviter_user_id: this.inviterId,
                    user_coupon_id : this.couponList[this.selectCouponIndex] ? this.couponList[this.selectCouponIndex]['info']['id'] : (this.selectCouponIndex === -2 ? '' : undefined),
                }).then(res => {
					self.isInitialized = true;
					if (res.data.order_detail && res.data.order_detail.discount_detail) {
						for(let index in res.data.order_detail.discount_detail){
							if(res.data.order_detail.discount_detail[index]['name'] === '优惠券优惠'){
								res.data.order_detail.discount_detail.splice(index, 1);
							}
						}
					}

                    self.orderInfo = res.data.order_detail;
					self.inviterNickname = self.orderInfo.inviter_user_nickname
                    self.cardList = res.data.user_card_list;
                    self.userCoupon = res.data.user_coupon;
                    self.payType = res.data.order_detail.payment_method;
                    // 油种类名称分割
                    let gunNumNameArr = self.orderInfo.detail.oil_type.name.split(' ')
                    self.orderInfo.detail.oilModel = gunNumNameArr[0]
                    self.orderInfo.detail.oilName = gunNumNameArr[1]
                    // 如果油卡数量为零则直接return提示用户开卡
                    if (!self.cardList.length) {
                        return self.cardIsNull = true
                    }
                    // 选择卡片
					if (self.cardInfos.length <= 0) {
						self.cardInfos = [];
						for (let item of self.cardList) {
							if (item.is_select) {
								self.cardInfos.push(item);
							}
						}
					}

                    // 为微信支付则隐藏油卡信息单元格
                    self.showCardCell = self.payType === 'card';
                }).catch(err => {
                    self.$notify({ type: 'danger', message: err.msg })
					self.$router.replace({name: 'Oiling'})
                }).finally(() => {
                    self.isLoading = false
                })
            },

            // 选择油卡
			showCardPop() {
				this.cardInfosReport = [].concat(this.cardInfos)
				this.showCard = true;
			},

            selectCard (card) {
                if (!card.disabled) {
					let index = this.cardIds.indexOf(card.id);
					if (index === -1) {
						if (this.cardInfos.length > 0) {
							if (this.isCardAllGift) {
								if (card.type === 'GiftCard') {
									this.cardInfos.push(card);
								} else {
									this.$notify({ type: 'danger', message: '只有礼品卡可以多选' })
									return
								}
							} else {
								this.cardInfos = [];
								this.cardInfos.push(card);
								return
							}
						} else {
							this.cardInfos.push(card);
							return
						}
					} else {
						this.cardInfos.splice(index, 1);
						return
					}
                }
            },

			cancelSelectCard() {
				this.showCard = false;
				this.cardInfos = [].concat(this.cardInfosReport)
			},

			confirmSelectCard () {
				if (this.cardInfos.length === 0) {
					this.$notify({ type: 'danger', message: '请选择至少一张油卡' })
					return
				}
				this.showCard = false
				this.getOrderCheckout()
			},

            submitClick(){
                let self = this;
                if(self.payType === 'card'){
                    api.request('/user/is_payment_password').then(res => {
                        if(!res.data.is_payment_pasword){
                            self.$beilinTools.setPaymentPasswordPopup().open();
                            self.$toast('您还未设置支付密码，请设置');
                        }else{
                            self.paymentPassword = '';
                            self.showPaymentPassword = true;
                        }
                    });
                }else{
                    self.payment();
                }
            },
			//支付成功后清除邀请人
			removeInviter() {
				if (this.inviterId) {
					localStorage.removeItem('consumeInviterInfo');
				}
				this.inviterId = '';
				this.inviterNickname = '';
			},
            // 支付订单
            payment () {
                let self = this;
                this.paying = true
				this.$toast.loading({
                    message: '支付中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                api.request('/order/payment', {
                    site_oil_gun_id: this.gunNumId, // 油枪ID
                    order_id: this.orderInfo.detail.order_id, // 订单ID
                    payment_method: this.payType, // 支付方式
                    user_card_id: this.cardIds,  // 卡片ID
                    user_coupon_id : this.couponList[this.selectCouponIndex] ? this.couponList[this.selectCouponIndex]['info']['id'] : '',
                    payment_password : this.paymentPassword,
					inviter_user_id: this.inviterId
                }).then(res => {
                    if(this.payType === 'card' || !res.data.payment_info){
						self.$toast.clear();
						self.removeInviter();
                        self.$toast.success({
                            message: '支付成功',
                            onClose(){
                                // 跳转到订单页面
                                self.$router.push({
                                    name: 'ConsumeDetail',
                                    query : {
                                        orderNo: res.data.order_no,
                                    }
                                });
                            },
                        });

                    }else if(this.payType === 'wechat_jsapi'){
                        let payInfo = JSON.parse(res.data.payment_info);
                        let order_id = res.data.order_no;
                        common.wechatPayReady(payInfo.appId, () => {
                            wx.chooseWXPay({
                                timestamp: payInfo.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                                nonceStr: payInfo.nonceStr, // 支付签名随机串，不长于 32 位
                                package: payInfo.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
                                signType: payInfo.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                                paySign: payInfo.paySign, // 支付签名
                                // 支付成功后的回调函数
                                success: (res) => {
                                    self.$toast.clear();
                                    self.removeInviter();
                                    self.$toast.success({
                                        message: '支付成功',
                                        onClose(){
                                            // 跳转到订单页面
                                            self.$router.push({
                                                name: 'ConsumeDetail',
                                                query : {
                                                    orderNo: res.data.order_no,
                                                }
                                            });
                                        }
                                    });
                                },
                                cancel(){
                                    self.$toast.clear();
                                    self.$toast.fail('正在取消订单');
                                    api.request('/order/cancel', {
                                        order_no: order_id
                                    }).then(res => {
                                        self.$toast.fail('订单已取消');
                                        self.$router.push({
                                            name: 'ConsumeDetail',
                                            query : {
                                                orderNo: res.data.order_no,
                                            }
                                        });
                                    }).catch(res => {
                                        self.$toast.fail('订单取消失败');
                                    });
                                    // 跳转到订单页面
                                },
                                fail: (err) => {
                                    self.$toast.clear();
                                    self.$notify({ type: 'danger', message: err.errMsg })
                                },
                            });
                        });
                    }
                    // this.$router.go(-1)
                }).catch(err => {
					self.$toast.clear();
                    this.$notify(err.msg);
                    this.paymentPassword = '';
                }).finally(() => {
                    this.paying = false
                })
            },
            couponChange(index){
                this.selectCouponIndex = index;
                this.showCoupon = false;
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../style/base.scss';
    @import '../../style/themeify.scss';
    *{
        @include themeify{
            /deep/.van-coupon-cell__value--selected {
                color: themed('colorText');
            }

            .order-container {
                padding-bottom: 70px;
            }

            .order-item-tag {
                background-color: themed('colorTag');
            }

            .order-item-submit {
                .van-submit-bar__price {
                    color: themed('colorText');
                    font-size: 0.4rem;
                }
                .van-submit-bar__price--integer {
                    color: themed('colorText');
                    font-size: 0.6rem;
                }
                .van-button {
                    background: linear-gradient(to right,themed('colorGradientLeft'),themed('colorGradientRight'));
                }
            }

            .van-cell,
            .van-cell-group__title,
            .van-submit-bar__bar {
                padding-left: 20px;
                padding-right: 20px;
            }

            .detail-container .van-cell__value {
                font-size: 16px;
            }

            .payment-container {
                position: relative;

                .van-cell .van-cell__title {
                    margin-left: 10px;
                }
                .van-cell__value{
                    position: static;
                    overflow: auto;
                }
                .payment-balance{
                    flex: initial;
                    font-size: 16px;
                }
                .payment-hint{
                    color: themed('colorText');
                }

                .payment-loading {
                    position: absolute;
                    right: 20px;
                }
            }

            .money {
                font-size: 24px;
                color: themed('colorText');
                font-weight: 400;
            }

            .van-popup {
                .popup_tit {
                    border-bottom: none;
                    box-shadow: 0 5px 5px 0 rgba(0, 0, 0, .4);
                }

                .card-list-button {
                    background-color: themed('colorButton');
                    border-color: themed('colorButton');
                    color: #fff;
                }

				.card-list {
					height: 80vh;
					overflow-y: auto;
					display: flex;
					flex-flow: column;
					align-items: center;
					padding: 10px 0;
					background: #f6f6f6;
				}

                .card-item {
                    margin: 10px 0;
                    box-shadow: 0 0 10px 0 rgba(0, 0, 0, .4);
                }
            }

        }

		.item-selected {
			border: 5px solid themed('colorButton');


			.item-active-shade {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				display: flex;
				justify-content: flex-end;
				align-items: flex-end;
				background: rgba(0, 0, 0, .2);

				i {
					position: relative;
					display: block;
					width: 0;
					height: 0;
					border-top: transparent solid 15px;
					border-left: transparent solid 15px;
					border-bottom: themed('colorButton') solid 15px;
					border-right: themed('colorButton') solid 15px;
				}

				.text {
					position: absolute;
					right: -3px;
					bottom: -3px;
					display: block;
					z-index: 1000;
					width: 0;
					height: 0;
					border-top: transparent solid 15px;
					border-left: transparent solid 15px;
					border-bottom: themed('colorButton') solid 15px;
					border-right: themed('colorButton') solid 15px;
				}

				i:before {
					position: absolute;
					right: -17px;
					bottom: -17px;
					display: block;
					transform: rotate(-30deg);
				}

				span {
					position: absolute;
					font-size: 12px;
					right: 0px;
					bottom: 0px;
					z-index: 1001;
					display: block;
				}
			}

		}

		.item-active-shade {
			display: none;
		}

    }
</style>

<style lang="scss" scoped>
    .item-disable-shade {
        display: none;
        transition: all 0.3s;
        border-radius: 10px;
    }

    .item-disable {
        position: relative;
        box-shadow: 0 0 5px 0 rgba(0, 0, 0, .4);

        &:after {
            border: none;
        }

        .item-disable-shade {
			z-index: 1000;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            background: rgba(0, 0, 0, .2);

            .message {
                padding: 10px;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(0, 0, 0, .4);
            }

            span {
                margin-left: 10px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/oiling/Order.vue